import { FormValidationRule } from "../types";

type SwitchTable = { [index: string]: number };
type CalculatorTable = { [index: number]: number };

const switchTable: SwitchTable = {
    A: 1,
    B: 2,
    C: 3,
    D: 4,
    E: 5,
    F: 6,
    G: 7,
    H: 8,
    I: 9,
    J: 10,
    K: 11,
    L: 12,
    M: 13,
    N: 14,
    O: 15,
    P: 16,
    Q: 17,
    R: 18,
    S: 19,
    T: 20,
    U: 21,
    V: 22,
    W: 0,
};
const calculatorTableForFirstLetter: CalculatorTable = {
    0: 8,
    1: 7,
    2: 6,
    3: 5,
    4: 4,
    5: 3,
    6: 2,
};
const calculatorNumberForSecondLetter = 9;
const calculatorDivisor = 23;

const re = new RegExp(/^(\d{7})([a-zA-Z]{1,2})$/i);
const validPPSN: FormValidationRule = (control, value) => {
    let valid = true;
    if (control.type === "boi_ppsn" && (control.isRequired || value)) {
        valid = false;
    }
    let defaultErrorMessage = "You've entered an invalid PPSN.";

    const validStructure = value && re.test(value);
    if (!validStructure) {
        defaultErrorMessage = "PPSN must be between 8 and 9 characters, with at least one letter at the end.";
    }

    if (control.type === "boi_ppsn" && validStructure) {
        const digitPart = value.substr(0, 7);
        const firstLetter: string = value.substr(7, 1).toUpperCase();
        const secondLetter: string = value.substr(8, 1).toUpperCase();

        value = digitPart + firstLetter + secondLetter;

        let helperSum = 0;
        [...digitPart].forEach((charValue, charKey) => {
            helperSum += (charValue * calculatorTableForFirstLetter[charKey]);
        });

        if (value.length === 8) {
            const firstLetterInNumber = helperSum % calculatorDivisor;
            if (switchTable[firstLetter] === firstLetterInNumber) {
                valid = true;
            }
        } else {
            const secondLetterInNumber = switchTable[secondLetter];
            const secondLetterBasedHelperNumber = secondLetterInNumber * calculatorNumberForSecondLetter;
            helperSum += secondLetterBasedHelperNumber;
            const firstLetterInNumber = helperSum % calculatorDivisor;

            if (switchTable[firstLetter] === firstLetterInNumber &&
                switchTable[secondLetter] === secondLetterInNumber
            ) {
                valid = true;
            }
        }
    }

    return [valid, control.form_field_tab_boi_ppsn_invalid || defaultErrorMessage];
};

export default validPPSN;
